import script from "./book-a-visit.vue?vue&type=script&setup=true&lang=js"
export * from "./book-a-visit.vue?vue&type=script&setup=true&lang=js"

import "./book-a-visit.vue?vue&type=style&index=0&id=61315410&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61315410"]])

export default __exports__